import { Div, router } from '@codesuma/baseline'
import publicListsService, { PublicListEntry } from '../../../services/public-lists'
import { ListCircle } from '../../../components/list-circle'
import style from './index.module.css'

// Home-page section of public lists, below the user's own circles. They render
// as the same circles as the user's own lists, colored by slug — the hue the
// saved copy keeps (public-lists.ts saveCopy).
// Hidden entirely until there's something to show, so a fresh offline install
// never sees an empty or broken-looking section.
export const PublicListsStrip = () => {
    const base = Div()
    base.addClass(style.base)
    base.style({ display: 'none' })

    const head = Div()
    head.addClass(style.head)

    const title = Div('Discover Public lists!')
    title.addClass(style.title)

    const seeAll = Div('See all')
    seeAll.addClass(style.seeAll)
    seeAll.el.onclick = () => router.goto('/discover')

    head.append(title)

    const grid = Div()
    grid.addClass(style.grid)

    base.append(head, grid, seeAll)

    // Filled in place, so the home page's reference stays current.
    const circles: ReturnType<typeof ListCircle>[] = []

    const circle = (entry: PublicListEntry) => {
        const c = ListCircle({ id: entry.slug, name: entry.title, created_by: '', created_at: '', role: 'owner' })
        c.on('circle-open', () => router.goto('/l/' + entry.slug, { name: entry.title }))
        return c
    }

    // Only the first eight — the section is a taste of the catalog, "See all"
    // is the way into the rest.
    const render = (lists: PublicListEntry[]) => {
        if (!lists.length) return
        grid.empty()
        circles.splice(0, circles.length, ...lists.slice(0, 8).map(circle))
        grid.append(...circles)
        base.style({ display: 'block' })
    }

    // Instant paint from the cached catalog, then refresh. A failed fetch is
    // silent: the home page must never nag about a browsing extra.
    render(publicListsService.getCachedCatalog())
    publicListsService.getCatalog()
        .then(render)
        .catch(err => console.warn('Public lists offline:', err))

    return Object.assign(base, {
        // The home page moves these with its own circles (open morph, contract,
        // theme recolor).
        circles,
        // During the open morph the circles scatter or grow on their own; only
        // the strip's title, "See all" and hairline fade out around them.
        setChrome(visible: boolean) {
            head.style({ opacity: visible ? '' : '0' })
            seeAll.style({ opacity: visible ? '' : '0' })
            base.style({ borderColor: visible ? '' : 'transparent' })
        },
    })
}
